//
//
//
//
//
//
//
//
//

import IconImage from '../IconImage.vue';
import ItemListMixin from './ItemListMixin'
import { mapGetters, mapActions } from 'vuex';
import {CONTENT_MANAGER, CHATS, CONTACTS} from '../../store/modulesNames';
import {GET_SELECTED_CHAT, GET_MAIN_TYPE, GET_MERGED_CONTACT_BY_ID} from '../../store/gettersTypes';

import {ACT_LOAD_BOT_CONTACT} from "../../store/actionsTypes"
import {BOT_PROPS, CONTACT_FIELD_TYPES} from '../../constants'

export default {
    name: 'search-bots',
    mixins: [ItemListMixin],
    components: {IconImage},
    props: {
        items: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    data() {
        return {
            CONTACT_FIELD_TYPES
        }
    },
    computed: {
        photos() {
          return this.items.map(({cid}) => this.$store.getters['userdata/getPhotoUrlbyCid'](cid))
        },
        ...mapGetters(CONTACTS, [GET_MERGED_CONTACT_BY_ID]),
        ...mapGetters(CHATS, [GET_SELECTED_CHAT]),
        ...mapGetters(CONTENT_MANAGER, [GET_MAIN_TYPE])
    },
    methods: {
        async openBot(bot) {
            await this[ACT_LOAD_BOT_CONTACT](bot.cid)
            this.$store.dispatch('chats/update')
            this.$store.dispatch('chats/open', { cid: bot.cid, cidType: 'user'})
        },
        ...mapActions(CONTACTS, [ACT_LOAD_BOT_CONTACT])
    }
}
